import { ReactNode } from 'react';
import styled from 'styled-components';
import RadioItem from './RadioItem';

interface RadioButtonsOption {
  value: string,
  label: ReactNode
}

export interface RadioButtonsProps {
  value?: string,
  onChange?: (value: string) => void,
  defaultValue?: string,
  options: RadioButtonsOption[],
  className?: string
  style?: React.CSSProperties
}

const RadioButtons = ({value, onChange, options, className, style}: RadioButtonsProps) => {

  const handleChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <Container className={className} style={style}>
      {options.map((i) => (
        <RadioItem key={i.value} onClick={() => handleChange(i.value)} value={i.value === value} >
          {i.label}
        </RadioItem>
      ))}
    </Container>
  );
};

export default RadioButtons;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
`;